import { IKVProps } from "@src/Model/IKVProps"
import AxiosRequest from "@src/Utils/axios"

export function addUserContactCN(params: IKVProps = {}) {
    return AxiosRequest.post('/websiteApi/operation-manager/userContact/addUserContact', params)
}
export function queryHeadArticle(params: IKVProps = {}) {
    return AxiosRequest.get('/websiteApi/operation-manager/article/queryHeadArticle', params)
}
export function queryArticleContent(params: IKVProps = {}) {
    return AxiosRequest.post('/websiteApi/operation-manager/article/queryArticleContent', params)
}
export function searchArticleById(params: IKVProps, config?: any) {
    return AxiosRequest.get("/websiteApi/operation-manager/article/searchArticleById", params, config);
}

// 查询当前已有的业态
export function searchIndustry(params?: IKVProps, config?: any) {
    return AxiosRequest.get("/websiteApi/operation-manager/new/searchIndustry", params, config);
}


// 新增
export function addCaseContent(params: IKVProps, config?: any) {
    return AxiosRequest.post("/websiteApi/operation-manager/new/addArticleContent", params, config);
}
// 更新
export function updateCaseContent(params: IKVProps, config?: any) {
    return AxiosRequest.post(
        "/websiteApi/operation-manager/new/updateArticleContent",
        params,
        config
    );
}

// 查询详情
export function searchCaseById(params: IKVProps, config?: any) {
    return AxiosRequest.get("/websiteApi/operation-manager/new/searchArticleById", params, config);
}

// 查询轮询案例
export function queryPlayArticle(params: IKVProps, config?: any) {
    return AxiosRequest.get("/websiteApi/operation-manager/news/queryPlayArticle", params, config);
}

// 查询当前已有的业态
export function getAllShowIndustry(params: IKVProps, config?: any) {
    return AxiosRequest.get("/websiteApi/operation-manager/news/searchIndustry", params, config);
}

export function getList(params: IKVProps, config?: any) {
    return AxiosRequest.post("/websiteApi/operation-manager/news/queryArticleContent", params, config);
}

export function getDetail(params: IKVProps, config?: any) {
    return AxiosRequest.get("/websiteApi/operation-manager/news/searchArticleById", params, config);
}

